import { Link } from 'react-router';
import { Box, Button, Container, Stack, Typography } from '@mui/material';

import type { HeroBlockContent } from '@/types/database';

export function HeroBlockView({ content, basePath }: { content: HeroBlockContent; basePath: string }) {
  return (
    <Box sx={{ py: { xs: 8, md: 12 }, background: (theme) => theme.palette.primary.main, color: 'primary.contrastText' }}>
      <Container maxWidth="md">
        <Stack spacing={2} sx={{ alignItems: "center", textAlign: "center" }}>
          <Typography variant="h2" sx={{ fontWeight: 700 }}>{content.headline}</Typography>
          {content.subheadline ? (
            <Typography variant="h6" sx={{ opacity: 0.9 }}>{content.subheadline}</Typography>
          ) : null}
          {content.buttonText && content.buttonLink ? (
            <Button component={Link} to={`${basePath}${content.buttonLink}`} variant="contained" color="secondary">
              {content.buttonText}
            </Button>
          ) : null}
        </Stack>
      </Container>
    </Box>
  );
}
